//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CircleRipple from './CircleRipple'
import {base} from '../../common/mixins'

const types = ['default', 'rimless', 'primary', 'safety', 'warning', 'danger']
const sizes = ['normal', 'mini', 'small', 'large', 'huge']

export default {
  name: 'HButton',
  components: {
    [CircleRipple.name]: CircleRipple,
  },
  mixins: [base],
  props: {
    type: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    bgColor: {
      type: String,
      default: '',
    },
    opacity: {
      type: [String, Number],
      default: 0.77,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ripple: {
      type: Boolean,
      default: false,
    },
    rippleColor: {
      type: String,
      default: '',
    },
    rippleOpacity: {
      type: [String, Number],
      default: '',
    },
  },
  data () {
    return {
      showOpacity: false,
      rippleKey: 0,
      ripples: [],
      hasTouchEvent: 'ontouchstart' in document,
    }
  },
  computed: {
    buttonClass () {
      const res = []
      this.shadow && res.push('shadow')
      this.disabled && res.push('disabled')
      types.includes(this.type) && res.push(this.type)
      sizes.includes(this.size) && res.push(this.size)
      return res
    },
    buttonStyle () {
      return this.showOpacity
        ? {
          color: this.color,
          backgroundColor: this.bgColor,
          opacity: this.opacity,
        }
        : {
          color: this.color,
          backgroundColor: this.bgColor,
        }
    },
  },
  methods: {
    preventDefault (e) {
      // 移动浏览器中长按元素会触发显示菜单，导致touchend事件不会触发，需要阻止该行为
      e.preventDefault()
    },
    start (e) {
      if(this.disabled) return
      if(this.hasTouchEvent && !e.touches) return
      if(this.ripple) {
        const ripple = {
          key: this.rippleKey++,
          color: this.rippleColor,
          opacity: this.rippleOpacity,
          style: this.getRippleStyle(e),
        }
        this.ripples.push(ripple)
      } else {
        this.showOpacity = true
      }
    },
    end (e) {
      // TODO: android4上貌似触发touchmove事件之后不会再触发touchend事件，暂未对该情况做兼容处理
      if(this.hasTouchEvent && !e.touches) return
      if(this.ripple) {
        if(this.ripples.length === 0) return
        this.ripples.splice(0, 1)
      } else {
        // 添加一点延时，不然透明度变化太快，效果不明显
        setTimeout(() => {
          this.showOpacity = false
        }, 100)
      }
    },
    getRippleStyle (e) {
      const {target} = e
      const rect = target.getBoundingClientRect()
      const isTouchEvent = e.touches && e.touches.length
      const pointerClientX = isTouchEvent
        ? Math.floor(e.touches[0].clientX)
        : e.clientX
      const pointerClientY = isTouchEvent
        ? Math.floor(e.touches[0].clientY)
        : e.clientY
      const left = pointerClientX - rect.left
      const top = pointerClientY - rect.top
      const right = rect.right - pointerClientX
      const bottom = rect.bottom - pointerClientY
      const leftTopDiagLen = this.calcDiagLen(left, top)
      const rightTopDiagLen = this.calcDiagLen(right, top)
      const leftBottomDiagLen = this.calcDiagLen(left, bottom)
      const rightBottomDiagLen = this.calcDiagLen(right, bottom)
      const rippleCircleRadius = Math.ceil(
        Math.max(
          leftTopDiagLen,
          rightTopDiagLen,
          leftBottomDiagLen,
          rightBottomDiagLen
        )
      )
      const rippleCircleDiameter = rippleCircleRadius * 2
      return {
        width: `${rippleCircleDiameter}px`,
        height: `${rippleCircleDiameter}px`,
        left: `${left}px`,
        top: `${top}px`,
      }
    },
    calcDiagLen (a, b) {
      return Math.sqrt(a * a + b * b)
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/HButton/index.vue